import type { ClipboardEvent } from 'react'

import { isSupportedImageMimeType } from './chat-input-attachment-validation.helper'

export const extractImagesFromClipboard = (clipboardItems: DataTransferItemList): File[] => {
  const imageFileList: File[] = []

  for (const item of clipboardItems) {
    if (!isSupportedImageMimeType(item.type)) continue
    const file = item.getAsFile()
    if (file) imageFileList.push(file)
  }

  return imageFileList
}

export const handleImagePaste = (
  e: ClipboardEvent<HTMLTextAreaElement>,
  onFilesSelected?: (fileList: File[]) => void
): void => {
  const clipboardItems = e.clipboardData?.items
  if (!clipboardItems || !onFilesSelected) return

  const imageFileList = extractImagesFromClipboard(clipboardItems)

  if (imageFileList.length > 0) {
    e.preventDefault()
    onFilesSelected(imageFileList)
  }
}
